import { images } from '../constants';

const blogs = [
  {
    id: 1,
    image: images.blog1,
    category: "AI Applications",
    date: "2 Jun, 2024",
    admin: "Admin",
    heading: "Exploring the Frontiers of Robotics",
    content: "Robotics is changing how we live, work, and interact with machines every day.",
    important: {
      content: "From intelligent automation to humanoid helpers, robotics is transforming industries and everyday life. Understanding the latest advancements can help you stay ahead in a rapidly evolving tech landscape.",
      intro: "Tech Innovator"
    },
    paragraph: {
      para1: "Dive into the world of robotics and discover how machines are reshaping fields like manufacturing, healthcare, space exploration, and domestic living.",
      para2: "Explore different types of robots—from industrial arms to AI-powered service bots—and understand their practical applications and limitations.",
      para3: "Get insights into how robotics integrates with AI, machine learning, and IoT to solve complex tasks, improve efficiency, and enhance user experience. Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quam error, odit aut possimus natus dolorem provident, temporibus expedita iure incidunt amet accusantium cum, repellat assumenda dolores mollitia totam! Recusandae, voluptas.",
      para4: "Learn about the ethical, social, and economic implications of advanced robotics. Discover what the future may hold as innovation continues to push boundaries. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Harum soluta mollitia earum vero similique facilis quo corrupti asperiores, fugiat totam necessitatibus labore voluptate molestiae quam impedit vel. Error, minus aut."
    },
    gallery: [
      images.blog1Gallery1,
      images.blog1Gallery2
    ],
    tags: ["Robotics", "Innovation", "Technology"],
    comments: [
      {
        id: 1,
        image: images.blog1Comment1,
        name: "Benjamin Alexander",
        date: "04 Feb, 2025",
        content: "Fascinating read on how robotics is evolving! Loved the section on healthcare robots.",
        replies: [
          {
            id: 1,
            image: images.blog1Comment2,
            name: "Isabella Grace",
            date: "05 Feb, 2025",
            content: "Same here! It’s amazing how robots are helping doctors and patients alike."
          }
        ]
      },
      {
        id: 2,
        image: images.blog1Comment3,
        name: "Samuel James",
        date: "05 Feb, 2025",
        content: "This article really opened my eyes to the potential of robotics beyond the factory floor."
      }
    ]
  },
  {
    id: 2,
    image: images.blog2,
    category: "Data Analytics",
    date: "5 Jun, 2024",
    admin: "Admin",
    heading: "Unveiling the Power of Machine Learning",
    content: "Machine learning helps systems learn and improve without being explicitly programmed.",
    important: {
      content: "Machine learning is revolutionizing the way systems learn and adapt without being explicitly programmed. Understanding its fundamentals helps unlock smarter, data-driven solutions for the future.",
      intro: "Data Visionary"
    },
    paragraph: {
      para1: "Discover how machine learning algorithms are used to analyze data, recognize patterns, and make decisions with minimal human intervention.",
      para2: "Learn the differences between supervised, unsupervised, and reinforcement learning—each with unique approaches and real-world applications.",
      para3: "Understand how machine learning powers everything from recommendation engines and fraud detection to self-driving cars and predictive analytics. Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quam error, odit aut possimus natus dolorem provident, temporibus expedita iure incidunt amet accusantium cum, repellat assumenda dolores mollitia totam! Recusandae, voluptas.",
      para4: "Explore the challenges of bias, overfitting, and data quality, along with tips to build responsible and effective machine learning models. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Harum soluta mollitia earum vero similique facilis quo corrupti asperiores, fugiat totam necessitatibus labore voluptate molestiae quam impedit vel. Error, minus aut."
    },
    gallery: [
      images.blog2Gallery1,
      images.blog2Gallery2
    ],
    tags: ["MachineLearning", "AI", "Innovation"],
    comments: [
      {
        id: 1,
        image: images.blog2Comment1,
        name: "Emily Turner",
        date: "06 Feb, 2025",
        content: "Very informative! Loved the breakdown of the different types of learning models.",
        replies: [
          {
            id: 1,
            image: images.blog2Comment2,
            name: "Daniel Clark",
            date: "07 Feb, 2025",
            content: "Same here. It helped clarify some concepts I struggled with before."
          }
        ]
      },
      {
        id: 2,
        image: images.blog2Comment3,
        name: "Sophia Martin",
        date: "07 Feb, 2025",
        content: "This blog made machine learning feel a lot less intimidating. Great job!"
      }
    ]
  },
  {
    id: 3,
    image: images.blog3,
    category: "Computer Vision",
    date: "8 Jun, 2024",
    admin: "Admin",
    heading: "The Evolution and Impact of Virtual Reality",
    content: "Virtual reality offers immersive experiences for games, training, and real-world simulations.",
    important: {
      content: "Virtual Reality (VR) has transformed from a niche concept into a groundbreaking tool shaping entertainment, education, healthcare, and more. Understanding its journey reveals how immersive tech is redefining human experiences.",
      intro: "Immersion Specialist"
    },
    paragraph: {
      para1: "Trace the history of virtual reality—from early simulation experiments to modern VR headsets that transport users into fully interactive environments.",
      para2: "Explore how VR is enhancing gaming, revolutionizing education through virtual classrooms, and enabling therapeutic treatments in healthcare.",
      para3: "Learn about the hardware and software behind VR experiences, and how innovations in motion tracking, haptics, and graphics are pushing immersion to new heights. Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quam error, odit aut possimus natus dolorem provident, temporibus expedita iure incidunt amet accusantium cum, repellat assumenda dolores mollitia totam! Recusandae, voluptas.",
      para4: "Consider the societal and psychological implications of virtual reality, and the challenges in balancing digital escapism with real-world interaction. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Harum soluta mollitia earum vero similique facilis quo corrupti asperiores, fugiat totam necessitatibus labore voluptate molestiae quam impedit vel. Error, minus aut."
    },
    gallery: [
      images.blog3Gallery1,
      images.blog3Gallery2
    ],
    tags: ["VirtualReality", "Technology", "Innovation"],
    comments: [
      {
        id: 1,
        image: images.blog3Comment1,
        name: "Liam Bennett",
        date: "08 Feb, 2025",
        content: "This was such a cool overview of VR’s rise! The part about education blew my mind.",
        replies: [
          {
            id: 1,
            image: images.blog3Comment2,
            name: "Olivia Reynolds",
            date: "09 Feb, 2025",
            content: "Totally agree. Imagine learning history while standing in ancient Rome!"
          }
        ]
      },
      {
        id: 2,
        image: images.blog3Comment3,
        name: "Noah Mitchell",
        date: "09 Feb, 2025",
        content: "Great article! I’m really excited to see where VR goes next."
      }
    ]
  },
  {
    id: 4,
    image: images.blog4,
    category: "Cybersecurity Solutions",
    date: "11 Jun, 2024",
    admin: "Admin",
    heading: "Ensuring Security in the Age of Algorithms",
    content: "AI enhances data safety with intelligent systems that detect and stop cyber threats.",
    important: {
      content: "As algorithms increasingly govern decisions in finance, healthcare, and daily life, ensuring security and data privacy is more critical than ever. Understanding risks and safeguards can protect both individuals and organizations.",
      intro: "Cyber Guardian"
    },
    paragraph: {
      para1: "Explore how algorithms are used to process sensitive data and make critical decisions—often in real time—and what that means for security.",
      para2: "Learn about common algorithmic vulnerabilities, including data poisoning, model inversion, and adversarial attacks that threaten system integrity.",
      para3: "Discover strategies like encryption, multi-factor authentication, ethical AI, and transparency practices to defend against evolving cyber threats. Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quam error, odit aut possimus natus dolorem provident, temporibus expedita iure incidunt amet accusantium cum, repellat assumenda dolores mollitia totam! Recusandae, voluptas.",
      para4: "Understand the balance between innovation and regulation, and how governments and industries are shaping secure frameworks for algorithm-driven systems. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Harum soluta mollitia earum vero similique facilis quo corrupti asperiores, fugiat totam necessitatibus labore voluptate molestiae quam impedit vel. Error, minus aut."
    },
    gallery: [
      images.blog4Gallery1,
      images.blog4Gallery2
    ],
    tags: ["Security", "AI", "Technology"],
    comments: [
      {
        id: 1,
        image: images.blog4Comment1,
        name: "Ava Patterson",
        date: "12 Feb, 2025",
        content: "Really informative! I didn’t realize how vulnerable algorithms could be until now.",
        replies: [
          {
            id: 1,
            image: images.blog4Comment2,
            name: "Jackson Rivera",
            date: "13 Feb, 2025",
            content: "Same here. This gave me a whole new perspective on cybersecurity!"
          }
        ]
      },
      {
        id: 2,
        image: images.blog4Comment3,
        name: "Chloe Sanders",
        date: "13 Feb, 2025",
        content: "Great insights on protecting data in an AI-driven world. Thanks for sharing!"
      }
    ]
  },
  {
    id: 5,
    image: images.blog5,
    category: "Healthcare Solutions",
    date: "14 Jun, 2024",
    admin: "Admin",
    heading: "Understanding Artificial Intelligence",
    content: "Artificial intelligence powers smart machines that mimic human thinking and decision-making.",
    important: {
      content: "Artificial Intelligence (AI) is changing how we live, work, and think. From automation to creative tools, understanding its foundations helps us better navigate and shape the future it’s creating.",
      intro: "AI Analyst"
    },
    paragraph: {
      para1: "Learn what AI really is—beyond the buzzwords. Understand the difference between narrow AI, general AI, and the emerging concept of superintelligence.",
      para2: "Explore how AI is powering virtual assistants, chatbots, predictive systems, and even artistic creation, transforming countless industries.",
      para3: "Get a deeper look at the technologies behind AI, including neural networks, natural language processing, and computer vision. Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quam error, odit aut possimus natus dolorem provident, temporibus expedita iure incidunt amet accusantium cum, repellat assumenda dolores mollitia totam! Recusandae, voluptas.",
      para4: "Examine the ethical and social implications of AI—bias, job displacement, and the importance of human oversight in intelligent systems. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Harum soluta mollitia earum vero similique facilis quo corrupti asperiores, fugiat totam necessitatibus labore voluptate molestiae quam impedit vel. Error, minus aut."
    },
    gallery: [
      images.blog5Gallery1,
      images.blog5Gallery2
    ],
    tags: ["AI", "Technology", "Innovation"],
    comments: [
      {
        id: 1,
        image: images.blog5Comment1,
        name: "Mason Brooks",
        date: "15 Feb, 2025",
        content: "Loved the simple explanation of such a complex topic. Very insightful!",
        replies: [
          {
            id: 1,
            image: images.blog5Comment2,
            name: "Ella Watson",
            date: "16 Feb, 2025",
            content: "Agreed! The section on AI ethics was especially important to me."
          }
        ]
      },
      {
        id: 2,
        image: images.blog5Comment3,
        name: "Logan Wright",
        date: "16 Feb, 2025",
        content: "Great introduction to AI—clear and well-written. Looking forward to more!"
      }
    ]
  },
  {
    id: 6,
    image: images.blog6,
    category: "AI Applications",
    date: "17 Jun, 2024",
    admin: "Admin",
    heading: "AI's Role in Transforming Gaming",
    content: "AI in gaming creates smarter gameplay, responsive enemies, and dynamic player experiences.",
    important: {
      content: "Artificial Intelligence is redefining the gaming world—bringing smarter NPCs, personalized experiences, and dynamic storytelling. Discover how AI is leveling up the future of interactive entertainment.",
      intro: "Game Tech Strategist"
    },
    paragraph: {
      para1: "Explore how AI enhances gameplay through adaptive difficulty, realistic character behavior, and immersive game environments.",
      para2: "Learn how procedural generation powered by AI creates infinite game worlds, unique challenges, and new storytelling possibilities.",
      para3: "See how player data is analyzed to tailor gaming experiences, from customizing story arcs to improving matchmaking. Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quam error, odit aut possimus natus dolorem provident, temporibus expedita iure incidunt amet accusantium cum, repellat assumenda dolores mollitia totam! Recusandae, voluptas.",
      para4: "Understand the future potential and ethical considerations of AI in gaming—from emotional AI to player privacy and fairness. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Harum soluta mollitia earum vero similique facilis quo corrupti asperiores, fugiat totam necessitatibus labore voluptate molestiae quam impedit vel. Error, minus aut."
    },
    gallery: [
      images.blog6Gallery1,
      images.blog6Gallery2
    ],
    tags: ["Gaming", "AI", "Innovation"],
    comments: [
      {
        id: 1,
        image: images.blog6Comment1,
        name: "Ethan Clark",
        date: "18 Feb, 2025",
        content: "Really cool to see how AI is changing the way games are made and played!",
        replies: [
          {
            id: 1,
            image: images.blog6Comment2,
            name: "Lily Morgan",
            date: "19 Feb, 2025",
            content: "I love how NPCs feel smarter now—makes the games way more engaging."
          }
        ]
      },
      {
        id: 2,
        image: images.blog6Comment3,
        name: "Owen Carter",
        date: "19 Feb, 2025",
        content: "Great article. The future of gaming with AI looks amazing!"
      }
    ]
  },
  {
    id: 7,
    image: images.blog7,
    category: "AI Applications",
    date: "20 Jun, 2024",
    admin: "Admin",
    heading: "Pushing the Limits of Robotic Innovation",
    content: "Robotic technology advances daily, solving problems and performing tasks more efficiently.",
    important: {
      content: "From surgical precision to space exploration, robotics is pushing boundaries and unlocking new possibilities. Discover how cutting-edge innovations are shaping the future of intelligent machines.",
      intro: "Tech Innovator"
    },
    paragraph: {
      para1: "Explore the latest breakthroughs in robotics—from humanoid robots to autonomous drones—and how they're being applied across industries.",
      para2: "Understand how machine learning and AI are enabling robots to make decisions, learn from environments, and adapt in real time.",
      para3: "Get insights into collaborative robots (cobots) that work alongside humans to boost productivity and safety in workplaces. Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quam error, odit aut possimus natus dolorem provident, temporibus expedita iure incidunt amet accusantium cum, repellat assumenda dolores mollitia totam! Recusandae, voluptas.",
      para4: "Examine the challenges and opportunities in robotic development, including ethics, regulation, and the future of human-robot interaction. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Harum soluta mollitia earum vero similique facilis quo corrupti asperiores, fugiat totam necessitatibus labore voluptate molestiae quam impedit vel. Error, minus aut."
    },
    gallery: [
      images.blog7Gallery1,
      images.blog7Gallery2
    ],
    tags: ["Robotics", "Innovation", "AI"],
    comments: [
      {
        id: 1,
        image: images.blog7Comment1,
        name: "Grace Thompson",
        date: "21 Feb, 2025",
        content: "Fascinating read! Robotics has come such a long way—it’s exciting to see what’s next.",
        replies: [
          {
            id: 1,
            image: images.blog7Comment2,
            name: "Daniel Reed",
            date: "22 Feb, 2025",
            content: "The section on cobots was eye-opening. I had no idea they were already so common!"
          }
        ]
      },
      {
        id: 2,
        image: images.blog7Comment3,
        name: "Harper Young",
        date: "22 Feb, 2025",
        content: "Loved this! Makes me want to get into robotics myself. Thanks for the inspiration!"
      }
    ]
  },
  {
    id: 8,
    image: images.blog8,
    category: "Data Analytics",
    date: "23 Jun, 2024",
    admin: "Admin",
    heading: "Harnessing Machine Learning Potential",
    content: "Machine learning finds patterns in data to improve tools, apps, and digital services.",
    important: {
      content: "Machine Learning (ML) is driving smarter systems, predictive capabilities, and automation across industries. Understanding how to unlock its full potential is key to building tomorrow’s innovations.",
      intro: "ML Researcher"
    },
    paragraph: {
      para1: "Dive into the core concepts of machine learning—from supervised and unsupervised learning to reinforcement models shaping intelligent behavior.",
      para2: "Explore real-world applications of ML in healthcare, finance, transportation, and personalized technology solutions.",
      para3: "Understand the importance of data quality, model training, and bias mitigation in building ethical and effective ML systems. Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quam error, odit aut possimus natus dolorem provident, temporibus expedita iure incidunt amet accusantium cum, repellat assumenda dolores mollitia totam! Recusandae, voluptas.",
      para4: "See how businesses and developers are leveraging ML tools and frameworks like TensorFlow and Scikit-learn to build scalable solutions. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Harum soluta mollitia earum vero similique facilis quo corrupti asperiores, fugiat totam necessitatibus labore voluptate molestiae quam impedit vel. Error, minus aut."
    },
    gallery: [
      images.blog8Gallery1,
      images.blog8Gallery2
    ],
    tags: ["MachineLearning", "Technology", "AI"],
    comments: [
      {
        id: 1,
        image: images.blog8Comment1,
        name: "Sophia Bennett",
        date: "24 Feb, 2025",
        content: "This gave me a solid overview of ML without overwhelming me—great job!",
        replies: [
          {
            id: 1,
            image: images.blog8Comment2,
            name: "Jackson Hill",
            date: "25 Feb, 2025",
            content: "Agreed! I especially liked the part about model bias and data ethics."
          }
        ]
      },
      {
        id: 2,
        image: images.blog8Comment3,
        name: "Aria Flores",
        date: "25 Feb, 2025",
        content: "Perfect for beginners and still relevant for those already in the field."
      }
    ]
  },
  {
    id: 9,
    image: images.blog9,
    category: "Computer Vision",
    date: "25 Jun, 2024",
    admin: "Admin",
    heading: "Virtual Reality: Progress and Influence",
    content: "VR continues to evolve with realistic visuals and real-time user interaction features.",
    important: {
      content: "Virtual Reality (VR) is no longer science fiction—it's revolutionizing how we learn, train, design, and play. Explore the advancements and broad impact of immersive technologies.",
      intro: "Immersive Tech Analyst"
    },
    paragraph: {
      para1: "Discover how VR has evolved from bulky headsets and limited interactions to today's sleek, highly immersive experiences.",
      para2: "Learn about VR applications in fields like education, medicine, architecture, and gaming—where immersion enhances productivity and creativity.",
      para3: "Understand the technical challenges in VR development, such as motion sickness, rendering latency, and haptic feedback. Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quam error, odit aut possimus natus dolorem provident, temporibus expedita iure incidunt amet accusantium cum, repellat assumenda dolores mollitia totam! Recusandae, voluptas.",
      para4: "See what lies ahead with VR—from mixed reality integrations to virtual collaboration spaces that redefine how we connect. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Harum soluta mollitia earum vero similique facilis quo corrupti asperiores, fugiat totam necessitatibus labore voluptate molestiae quam impedit vel. Error, minus aut."
    },
    gallery: [
      images.blog9Gallery1,
      images.blog9Gallery2
    ],
    tags: ["VirtualReality", "Innovation", "Technology"],
    comments: [
      {
        id: 1,
        image: images.blog9Comment1,
        name: "Liam Hayes",
        date: "26 Feb, 2025",
        content: "I’ve seen VR change the classroom environment completely—so cool to read about more use cases!",
        replies: [
          {
            id: 1,
            image: images.blog9Comment2,
            name: "Avery Scott",
            date: "27 Feb, 2025",
            content: "Totally agree. The healthcare applications blew my mind!"
          }
        ]
      },
      {
        id: 2,
        image: images.blog9Comment3,
        name: "Zoe Campbell",
        date: "27 Feb, 2025",
        content: "Can’t wait to see how VR and AR come together in everyday life. Great article!"
      }
    ]
  },
  {
    id: 10,
    image: images.blog10,
    category: "Cybersecurity Solutions",
    date: "27 Jun, 2024",
    admin: "Admin",
    heading: "Safeguarding the Digital Era with AI",
    content: "AI systems protect sensitive information and monitor threats across digital environments.",
    important: {
      content: "In an age where data is currency, AI is playing a vital role in defending digital infrastructure. Explore how artificial intelligence is reshaping cybersecurity with speed and precision.",
      intro: "Cybersecurity Expert"
    },
    paragraph: {
      para1: "Learn how AI enhances cybersecurity by identifying threats in real time, detecting anomalies, and automating responses to cyberattacks.",
      para2: "Dive into real-world examples of AI-driven security tools protecting everything from personal devices to national infrastructure.",
      para3: "Understand the challenges, including algorithmic bias, adversarial attacks, and the need for transparency in AI-based security systems. Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quam error, odit aut possimus natus dolorem provident, temporibus expedita iure incidunt amet accusantium cum, repellat assumenda dolores mollitia totam! Recusandae, voluptas.",
      para4: "Explore the future of AI in cybersecurity—from self-healing networks to predictive threat intelligence that stops breaches before they begin. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Harum soluta mollitia earum vero similique facilis quo corrupti asperiores, fugiat totam necessitatibus labore voluptate molestiae quam impedit vel. Error, minus aut."
    },
    gallery: [
      images.blog10Gallery1,
      images.blog10Gallery2
    ],
    tags: ["Security", "AI", "Technology"],
    comments: [
      {
        id: 1,
        image: images.blog10Comment1,
        name: "Noah Rivera",
        date: "28 Feb, 2025",
        content: "AI is a game changer in cybersecurity—appreciate the balanced perspective this blog offers.",
        replies: [
          {
            id: 1,
            image: images.blog10Comment2,
            name: "Ella Morgan",
            date: "29 Feb, 2025",
            content: "Absolutely! The section on predictive threat detection was especially interesting."
          }
        ]
      },
      {
        id: 2,
        image: images.blog10Comment3,
        name: "Mason Clark",
        date: "29 Feb, 2025",
        content: "Good overview! It made complex topics accessible without oversimplifying them."
      }
    ]
  },
  {
    id: 11,
    image: images.blog11,
    category: "Healthcare Solutions",
    date: "29 Jun, 2024",
    admin: "Admin",
    heading: "Decoding the World of Artificial Intelligence",
    content: "AI reshapes modern life with smart assistants, automation, and advanced data processing.",
    important: {
      content: "Artificial Intelligence is everywhere—from voice assistants to autonomous vehicles. Get a clear understanding of what AI is, how it works, and where it’s headed in the future.",
      intro: "AI Research Analyst"
    },
    paragraph: {
      para1: "Explore the fundamental concepts behind AI, including machine learning, neural networks, and natural language processing.",
      para2: "Learn how AI is being applied across industries such as healthcare, finance, transportation, and entertainment.",
      para3: "Delve into ethical considerations, data privacy issues, and the importance of transparency in AI systems. Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quam error, odit aut possimus natus dolorem provident, temporibus expedita iure incidunt amet accusantium cum, repellat assumenda dolores mollitia totam! Recusandae, voluptas.",
      para4: "Gain insights into the future of AI, from general intelligence to human-AI collaboration and its impact on society. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Harum soluta mollitia earum vero similique facilis quo corrupti asperiores, fugiat totam necessitatibus labore voluptate molestiae quam impedit vel. Error, minus aut."
    },
    gallery: [
      images.blog11Gallery1,
      images.blog11Gallery2
    ],
    tags: ["AI", "MachineLearning", "Innovation"],
    comments: [
      {
        id: 1,
        image: images.blog11Comment1,
        name: "Emma Wilson",
        date: "01 Mar, 2025",
        content: "Such a well-written breakdown of AI! I finally feel like I understand the basics.",
        replies: [
          {
            id: 1,
            image: images.blog11Comment2,
            name: "Lucas Bennett",
            date: "01 Mar, 2025",
            content: "Agreed! The examples made everything so much easier to grasp."
          }
        ]
      },
      {
        id: 2,
        image: images.blog11Comment3,
        name: "Olivia Parker",
        date: "02 Mar, 2025",
        content: "I appreciate how this article touched on ethics too. That’s often overlooked!"
      }
    ]
  },
  {
    id: 12,
    image: images.blog12,
    category: "AI Applications",
    date: "1 Jul, 2024",
    admin: "Admin",
    heading: "How AI is Revolutionizing the Gaming Industry",
    content: "AI-driven games adjust difficulty, behavior, and storylines for more engaging play.",
    important: {
      content: "Artificial Intelligence is redefining the gaming experience—from smarter NPCs to personalized gameplay. Discover how AI is transforming the future of interactive entertainment.",
      intro: "Game Tech Analyst"
    },
    paragraph: {
      para1: "Explore how AI enhances gaming by creating more intelligent, responsive, and lifelike non-playable characters (NPCs).",
      para2: "Learn about adaptive difficulty, player behavior prediction, and procedurally generated environments driven by machine learning.",
      para3: "Understand the role of AI in real-time decision-making, immersive storytelling, and dynamic gameplay. Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quam error, odit aut possimus natus dolorem provident, temporibus expedita iure incidunt amet accusantium cum, repellat assumenda dolores mollitia totam! Recusandae, voluptas.",
      para4: "Look ahead at innovations such as AI-powered game design tools, player emotion tracking, and virtual game testers. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Harum soluta mollitia earum vero similique facilis quo corrupti asperiores, fugiat totam necessitatibus labore voluptate molestiae quam impedit vel. Error, minus aut."
    },
    gallery: [
      images.blog12Gallery1,
      images.blog12Gallery2
    ],
    tags: ["Gaming", "AI", "Technology"],
    comments: [
      {
        id: 1,
        image: images.blog12Comment1,
        name: "Liam Carter",
        date: "03 Mar, 2025",
        content: "Really cool breakdown of how AI is making games more engaging. Loved the NPC section!",
        replies: [
          {
            id: 1,
            image: images.blog12Comment2,
            name: "Sophia Turner",
            date: "03 Mar, 2025",
            content: "Totally! The adaptive gameplay insights were spot on."
          }
        ]
      },
      {
        id: 2,
        image: images.blog12Comment3,
        name: "Jackson Moore",
        date: "04 Mar, 2025",
        content: "This makes me excited about the future of gaming. Great read!"
      }
    ]
  }

];

export default blogs;